import React, { useState } from 'react';
import { getIpDateRange, type ReadingPlanDay } from '@soulhx/fs-common';
import { useTranslation } from 'react-i18next';
import { SHXButton, StandardButton } from '@soulhx/ui-common';
import { DateTime } from 'luxon';
import { useDispatch } from 'react-redux';
import { type ActiveInstantiatedPlan, updateDateForReadingPlan } from '@soulhx/client-store';
import { Modal } from 'react-bootstrap';
import { PlanCalendarView } from '../../PlanCalendarView.js';

interface ICRPHeader {
  showTitle: boolean;
  data: ReadingPlanDay[];
  activePlans: ActiveInstantiatedPlan[];
  dateToShow: DateTime;
}
export const CurrentReadingPlanHeader = ({ showTitle, data, activePlans, dateToShow }: ICRPHeader) => {
  const { t } = useTranslation(['plan']);
  const dispatch = useDispatch();
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false);

  // navigation is limited to the dates the user's plans actually cover
  const range = getIpDateRange(activePlans.flatMap((p) => p.days));
  const earliestDate = range ? DateTime.fromISO(range.start) : DateTime.now();
  const latestDate = range ? DateTime.fromISO(range.end) : DateTime.now();

  return (
    <>
      {showTitle && <h5 className="text-center">{t('plan:current.heading', { count: data.length })}</h5>}
      <h5 className="d-flex justify-content-center">
        <StandardButton
          type="left"
          onClick={() => {
            const newDate = dateToShow.minus({ day: 1 });
            dispatch(updateDateForReadingPlan(newDate.toISODate()!));
          }}
          disabled={dateToShow.startOf('day') <= earliestDate.startOf('day')}
        />

        <SHXButton variant="outline-dark" onClick={() => setShowDatePicker(true)}>
          {dateToShow.toLocaleString()}
        </SHXButton>

        <StandardButton
          type="right"
          onClick={() => {
            const newDate = dateToShow.plus({ day: 1 });
            dispatch(updateDateForReadingPlan(newDate.toISODate()!));
          }}
          disabled={dateToShow.startOf('day') >= latestDate.startOf('day')}
        />
      </h5>
      <Modal show={showDatePicker} onHide={() => setShowDatePicker(false)}>
        <Modal.Header closeButton>{t('plan:current.chooseDateHeading')}</Modal.Header>
        <Modal.Body>
          <PlanCalendarView dateToShow={dateToShow} clickHandler={() => setShowDatePicker(false)} />
        </Modal.Body>
      </Modal>
    </>
  );
};
